import { render, staticRenderFns } from "./Skill.vue?vue&type=template&id=66379222&scoped=true"
import script from "./Skill.vue?vue&type=script&lang=js"
export * from "./Skill.vue?vue&type=script&lang=js"
import style0 from "./Skill.vue?vue&type=style&index=0&id=66379222&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66379222",
  null
  
)

export default component.exports